import Menu from './Compartido/Menu.jsx';
import TextosConfirmadaReserva from './ConfirmadaReserva/TextosConfirmadaReserva.jsx';
import Footer from './Compartido/Footer.jsx';

const ConfirmadaReserva = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <TextosConfirmadaReserva
                lang={props.lang}
                datostransferencia={props.datostransferencia}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    )
}

export default ConfirmadaReserva;
